import firebase from 'firebase/app';
import 'firebase/auth';

export const addPoint = ({ commit }, e) => commit('addPoint', e);

export const delPoint = ({ commit }, e) => commit('delPoint', e);

export const addGameInfo = ({ commit }, e) => commit('addGameInfo', e);

export const addManualLabel = ({ commit }, e) => commit('addManualLabel', e);

export const delManualLabel = ({ commit }, e) => commit('delManualLabel', e);

export const addManualArray = ({ commit }, e) => commit('addManualArray', e);

export const popManualArray = ({ commit }, e) => commit('popManualArray', e);

export const updHits = ({ commit }, e) => commit('updHits', e);

export const SignInMail = ({ commit }, e) => {
  commit('storeIsLoading', true);
  firebase.auth().signInWithEmailAndPassword(e.username, e.password)
    .then((obj) => {
      const user = obj.user;
      commit('SignIn', { uid: user.uid });
    })
    .catch(() => {
      alert('ユーザーIDまたはパスワードが異なります。');
    })
    .finally(() => {
      commit('storeIsLoading', false);
    });
};

export const SignInGoogle = ({ commit }) => {
  // Appコンポーネントのcreate時にリダイレクト後なら呼ばれる
  commit('storeIsLoading', true);
  firebase.auth().getRedirectResult()
    .then((obj) => {
      const user = obj.user;
      commit('SignIn', { uid: user.uid });
    })
    .catch(() => {
      alert('ログイン処理に失敗しました。しばらくしてから再度やり直してください。');
    })
    .finally(() => {
      commit('setRedirect', false);
      commit('storeIsLoading', false);
    });
};

export const SignIn = ({ commit }, e) => commit('SignIn', e);

export const SignOut = ({ commit }, e) => commit('SignOut', e);

export const storeIsLoading = ({ commit }, e) => commit('storeIsLoading', e);

export const reset = ({ commit }, e) => commit('reset', e);

export const setRedirect = ({ commit }, e) => commit('setRedirect', e);

export const setMessage = ({ commit }, e) => commit('setMessage', e);

export const delGameData = ({ commit }, e) => commit('delGameData', e);

export const linkShareFlgOn = ({ commit }, e) => commit('linkShareFlgOn', e);

export const publicShareFlgOn = ({ commit }, e) => commit('publicShareFlgOn', e);

export const setGameData = ({ commit }, e) => commit('setGameData', e);

export const setGameDataOption = ({ commit }, e) => commit('setGameDataOption', e);



// WEBPACK FOOTER //
// ./src/vuex/actions.js